// 상품 문구 조립 (어드민 설계 10절 B1). apps/web StorePage·결제 완료·내역과 apps/admin 미리보기가 같은 함수를 쓴다.
// DB·API 는 코드만 내려주고(productId·badge), 문구는 여기(클라 소유). 상품 별칭(한 조각 등)은 없다 — 상품은 브릭 수량으로만 부른다(AC0-263).

const won = (n: number) => n.toLocaleString("ko-KR");

/** 상품 표기 "브릭 {N}개" (결제 완료·내역·웹 주문명 = 지급량). 상점 행(PackageRow label)도 기본 수량(products.bricks)으로 같은 함수, 보너스는 칩 */
export const productName = (p: { bricks: number }): string => `브릭 ${won(p.bricks)}개`;

/** 보너스 칩 "+500" (0 이면 null) */
export const bonusLabel = (p: { bonus: number }): string | null => (p.bonus > 0 ? `+${won(p.bonus)}` : null);

/** 강조 행(시안 20,000): popular 배지 코드. 문구 칩은 없다 */
export const isHighlighted = (p: { badge: string | null }): boolean => p.badge === "popular";

/** 가격 라벨 "₩4,900" (Play 로컬 가격은 네이티브 Billing 뒤 폴백) */
export const priceLabel = (p: { priceKrw: number }): string => `₩${won(p.priceKrw)}`;
